import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mahdoodeFaniColumn } from "Constants/TableColumns";
import { read } from "Helpers/LocalStorage";
import { getMahdoodeFani } from "Stores/actions";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Translator from "Languages/Utility/Translator";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import { useTranslation } from "react-i18next";

function MahdoodeFaniYaraghTable() {
  const { t } = useTranslation();
  const {
    selectedBazsho,
    mahdoodeFani,
    mahdoodeFaniPagination,
    isWidthFani,
    isHeightFani,
    selectedBrandYaragh
  } = useSelector((state) => ({
    selectedBazsho: state.yaragh.selectedBazsho,
    mahdoodeFani: state.yaragh.mahdoodeFani,
    mahdoodeFaniPagination: state.yaragh.mahdoodeFaniPagination,
    isWidthFani: state.yaragh.isWidthFani,
    isHeightFani: state.yaragh.isHeightFani,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
  }));

  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState([]);
  const [columns, setColumns] = useState();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (selectedBazsho) {
      const updateFittingsColumn = [...mahdoodeFaniColumn];
      updateFittingsColumn[3].hidden = !isWidthFani;
      updateFittingsColumn[4].hidden = !isHeightFani;
      setColumns(updateFittingsColumn);
      (async () => { await getData(1, 5) })();
    }
    return () => setColumns(null);
  }, [selectedBazsho, isWidthFani, isHeightFani]);

  useEffect(() => {
    if (mahdoodeFani) {
      setTblData(mahdoodeFani);
      setTotal(mahdoodeFaniPagination.Total);
      setCurrentPage(mahdoodeFaniPagination.Page);
      setSizePerPage(mahdoodeFaniPagination.Limit);
    }
  }, [mahdoodeFani, mahdoodeFaniPagination]);

  const getData = async (_page, size_per_page, search = null) => {
    setLoading(true);
    try{
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdPop: +selectedBazsho.Id,
        Limit: size_per_page ? size_per_page : sizePerPage,
        Page: _page ? _page : currentPage,
        ...search
      };
      await dispatch(getMahdoodeFani(params));
    } catch (err) { console.log('[onGetMahdoodeFani]', err) }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }

  const setValue = async (name, value) => {
    setSearch(value);
  }

  const onSearch = async (e) => {
    e.preventDefault();
    setCurrentPage(1);
    await getData(1, 5, { name: search });
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    setCurrentPage(1);
    await getData(1, 5);
  }

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") await getData(page, sizePerPage);
  }

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container>
        <Grid item lg={4} md={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
      {selectedBazsho && selectedBrandYaragh && (
        <div className="yaragh-upper-selected-info">
          <p>{selectedBazsho.Name}</p>
          <p>{selectedBrandYaragh.Name}</p>
        </div>
      )}
      {
        columns &&
        <RemoteTable
          data={tblData}
          keyField="num"
          columns={columns}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
          title={<Translator id="list_Fani" />}
          hideBorderTop
        />
      }
    </Fragment>
  );
}

export default MahdoodeFaniYaraghTable;
